var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('focus-trap', {
    attrs: {
      "active": ""
    }
  }, [_c('div', {
    staticClass: "modal-window"
  }, [_c('div', {
    staticClass: "modal-window-text"
  }, [_c('h3', {
    attrs: {
      "id": "dialog-title"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.heading) + "\n      ")]), _c('p', {
    attrs: {
      "tabindex": "0",
      "id": "dialog-description"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]), _c('a', {
    ref: "modalCloseButton",
    staticClass: "modal-close-button progress modal-error",
    attrs: {
      "aria-label": "Close modal",
      "role": "button",
      "tabindex": "0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.buttonClose)
    },
    on: {
      "click": _vm.closeModal,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.closeModal($event);
      }
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }